import { useCallback, useEffect, useRef, useState } from 'react';
import { copyText } from '../lib/clipboard';

export function useCopyFormLink(url) {
  const [status, setStatus] = useState('idle');
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  useEffect(() => {
    if (status !== 'copied') return;
    const timer = setTimeout(() => setStatus('idle'), 2500);
    return () => clearTimeout(timer);
  }, [status]);
  const copyLink = useCallback(async () => {
    const success = await copyText(url);
    if (mounted.current) setStatus(success ? 'copied' : 'manual');
  }, [url]);
  return { copied: status === 'copied', copyError: status === 'manual', copyLink };
}